<template>
  <div>
    <b-modal
      id="modalParticipantes"
      centered
      hide-footer
      size="xl"
      title="Lista para Confirmação de Frequência"
      @show="onModalShow"
      @hidden="onModalHidden"
    >
      <form ref="addPresenca" @submit.prevent="submit">
        <div
          v-if="mensagemAlerta"
          class="alert alert-warning mb-3"
          role="alert"
        >
          {{ mensagemAlerta }}
        </div>

        <div class="table-responsive presenca-table-wrapper">
          <table
            class="table table-sm table-bordered table-hover mb-0 presenca-table"
          >
            <thead class="thead-light">
              <tr>
                <th class="align-middle">NIS/CPF</th>
                <th class="align-middle">Nome</th>
                <th class="align-middle text-center">Sexo</th>
                <th class="align-middle text-center">Data de Nascimento</th>
                <th class="align-middle text-center">Situação</th>
                <th class="align-middle text-center confirmar-coluna">
                  Confirmar
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="participante in participantes"
                :key="getParticipanteId(participante)"
              >
                <td class="align-middle font-weight-bold">
                  {{ getNisCpf(participante) }}
                </td>

                <td class="align-middle nome-participante">
                  {{ getNome(participante) }}
                </td>

                <td class="align-middle text-center">
                  {{ getSexo(participante) }}
                </td>

                <td class="align-middle text-center">
                  {{ getDataNascimento(participante) }}
                </td>

                <td class="align-middle text-center">
                  {{ getSituacao(participante) }}
                </td>

                <td class="align-middle text-center">
                  <div
                    class="d-flex justify-content-center align-items-center flex-wrap"
                  >
                    <div class="form-check form-check-inline mr-3 mb-0">
                      <input
                        :id="
                          'participante-' +
                          getParticipanteId(participante) +
                          '-sim'
                        "
                        v-model="marcacoes[getParticipanteId(participante)]"
                        class="form-check-input"
                        type="radio"
                        :name="
                          'participacao-' + getParticipanteId(participante)
                        "
                        :value="true"
                        @change="onMarcacaoManual"
                      />
                      <label
                        class="form-check-label font-weight-bold"
                        :for="
                          'participante-' +
                          getParticipanteId(participante) +
                          '-sim'
                        "
                      >
                        Sim
                      </label>
                    </div>

                    <div class="form-check form-check-inline mb-0">
                      <input
                        :id="
                          'participante-' +
                          getParticipanteId(participante) +
                          '-nao'
                        "
                        v-model="marcacoes[getParticipanteId(participante)]"
                        class="form-check-input"
                        type="radio"
                        :name="
                          'participacao-' + getParticipanteId(participante)
                        "
                        :value="false"
                        @change="onMarcacaoManual"
                      />
                      <label
                        class="form-check-label font-weight-bold"
                        :for="
                          'participante-' +
                          getParticipanteId(participante) +
                          '-nao'
                        "
                      >
                        Não
                      </label>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-if="!participantes.length">
                <td colspan="6" class="text-center text-muted py-4">
                  Nenhum participante encontrado.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-3 align-items-center">
          <div class="col-md-6 mb-2 mb-md-0">
            <select
              v-model="modoConfirmacao"
              class="custom-select custom-select-sm modo-confirmacao"
              :disabled="salvando || !participantes.length"
              @change="alterarModoConfirmacao"
            >
              <option value="manual"></option>
              <option value="todos_sim">Confirmar todos como Sim</option>
              <option value="todos_nao">Confirmar todos como Não</option>
            </select>
          </div>

          <div class="col-md-6 text-right">
            <button
              ref="btnSalvar"
              class="btn btn-success btn-submit-modal"
              data-style="zoom-in"
              type="submit"
              :disabled="salvando || !participantes.length"
            >
              <i class="mdi mdi-content-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalPresencaParticipantes",

  props: {
    saveUrl: {
      type: String,
      default: "api/dashboard/update/participantes/atividades",
    },
    model: {
      type: String,
      default: null,
    },
    modelId: {
      type: [Number, String],
      default: null,
    },
    participantes: {
      type: Array,
      default: function () {
        return [];
      },
    },
    participantesPresentes: {
      type: Array,
      default: function () {
        return [];
      },
    },
    participantesAusentes: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  data: function () {
    return {
      marcacoes: {},
      modoConfirmacao: "manual",
      mensagemAlerta: "",
      salvando: false,
      modalAberto: false,
    };
  },

  computed: {
    idsPresentes: function () {
      return this.participantes
        .filter(function (participante) {
          return this.marcacoes[this.getParticipanteId(participante)] === true;
        }, this)
        .map(function (participante) {
          return this.getParticipanteId(participante);
        }, this);
    },

    idsAusentes: function () {
      return this.participantes
        .filter(function (participante) {
          return this.marcacoes[this.getParticipanteId(participante)] === false;
        }, this)
        .map(function (participante) {
          return this.getParticipanteId(participante);
        }, this);
    },

    participantesSemMarcacao: function () {
      return this.participantes.filter(function (participante) {
        var id = this.getParticipanteId(participante);

        return this.marcacoes[id] !== true && this.marcacoes[id] !== false;
      }, this);
    },
  },

  watch: {
    participantes: function () {
      this.reinicializarMarcacoesSeModalAberto();
    },
    participantesPresentes: function () {
      this.reinicializarMarcacoesSeModalAberto();
    },
    participantesAusentes: function () {
      this.reinicializarMarcacoesSeModalAberto();
    },
  },

  methods: {
    reinicializarMarcacoesSeModalAberto: function () {
      if (this.modalAberto) {
        this.inicializarMarcacoes();
      }
    },

    onModalShow: function () {
      this.modalAberto = true;
      this.inicializarMarcacoes();
    },

    onModalHidden: function () {
      this.modalAberto = false;
      this.mensagemAlerta = "";
      this.modoConfirmacao = "manual";
    },

    inicializarMarcacoes: function () {
      var idsPresentes = this.normalizarIds(this.participantesPresentes);
      var idsAusentes = this.normalizarIds(this.participantesAusentes);
      var marcacoes = {};

      this.mensagemAlerta = "";
      this.modoConfirmacao = "manual";

      this.participantes.forEach(function (participante) {
        var id = this.getParticipanteId(participante);
        var idNormalizado = String(id);

        if (idsPresentes.indexOf(idNormalizado) !== -1) {
          marcacoes[id] = true;
          return;
        }

        if (idsAusentes.indexOf(idNormalizado) !== -1) {
          marcacoes[id] = false;
          return;
        }

        marcacoes[id] = null;
      }, this);

      this.marcacoes = marcacoes;
    },

    normalizarIds: function (lista) {
      return (lista || []).map(function (item) {
        if (item && typeof item === "object") {
          return String(item.id);
        }

        return String(item);
      });
    },

    onMarcacaoManual: function () {
      this.limparAlerta();
    },

    emitirMarcacoesSalvas: function () {
      this.$emit("presentes", this.idsPresentes);
      this.$emit("ausentes", this.idsAusentes);
    },

    limparAlerta: function () {
      if (!this.participantesSemMarcacao.length) {
        this.mensagemAlerta = "";
      }
    },

    getParticipanteId: function (participante) {
      return participante && participante.id ? participante.id : null;
    },

    getNisCpf: function (participante) {
      return (
        participante.nis ||
        participante.cpf ||
        participante.cpf_formatado ||
        "-"
      );
    },

    getNome: function (participante) {
      return participante.nome || participante.name || "-";
    },

    getSexo: function (participante) {
      return participante.sexo == 1
        ? "Masculino"
        : participante.sexo == 2
        ? "Feminino"
        : "-";
    },

    getDataNascimento: function (participante) {
      return (
        participante.data_nascimento_formatada ||
        participante.data_nascimento ||
        "-"
      );
    },

    getSituacao: function (participante) {
      if (participante.situacao_prioritaria == null) {
        return "-";
      }
      return this.isPrioritario(participante)
        ? "Prioritário"
        : "Não Prioritário";
    },

    isPrioritario: function (participante) {
      var situacao = participante.situacao_prioritaria;

      if (Array.isArray(situacao)) {
        return !(situacao.length === 1 && String(situacao[0]) === "1");
      }

      return String(situacao).trim() !== "[1]";
    },

    alterarModoConfirmacao: function () {
      if (this.modoConfirmacao === "manual") {
        return;
      }

      var marcarComoPresente = this.modoConfirmacao === "todos_sim";
      var self = this;

      this.mensagemAlerta = "";

      this.confirmarDefinicaoParaTodos(marcarComoPresente).then(function (
        confirmado
      ) {
        if (!confirmado) {
          self.modoConfirmacao = "manual";
          return;
        }

        self.definirTodos(marcarComoPresente);
        // self.salvar();
      });
    },

    definirTodos: function (presente) {
      var marcacoes = {};

      this.participantes.forEach(function (participante) {
        marcacoes[this.getParticipanteId(participante)] = presente;
      }, this);

      this.marcacoes = marcacoes;
    },

    confirmarDefinicaoParaTodos: function (presente) {
      var resposta = presente ? "sim" : "não";
      var mensagem = "Deseja definir " + resposta + " para todos os usuários?";

      if (this.$bvModal && this.$bvModal.msgBoxConfirm) {
        return this.$bvModal.msgBoxConfirm(mensagem, {
          title: "Confirmar frequência",
          okTitle: "Sim",
          cancelTitle: "Cancelar",
          okVariant: "success",
          cancelVariant: "secondary",
          centered: true,
        });
      }

      return Promise.resolve(window.confirm(mensagem));
    },

    validarMarcacoes: function () {
      if (this.participantesSemMarcacao.length) {
        this.mensagemAlerta =
          "Existe(m) usuário(s) sem marcação de participação";
        return false;
      }

      this.mensagemAlerta = "";
      return true;
    },

    getIdRegistro: function () {
      var model = this.model || this.$attrs.model;

      if (
        model === "ScfvGrupo" ||
        model === "Modules\\Scfv\\Entities\\ScfvGrupo"
      ) {
        return this.modelId || this.$attrs.modelId;
      }

      return this.modelId || this.$attrs.modelId || this.$route.params.id;
    },

    submit: function () {
      if (!this.validarMarcacoes()) {
        return;
      }

      this.salvar();
    },

    salvar: function () {
      var self = this;
      var ladda = null;
      var dados = {
        id: this.getIdRegistro(),
        presenca: this.idsPresentes,
        participantes_ausentes: this.idsAusentes,
      };

      this.salvando = true;

      if (this.$refs.btnSalvar && typeof Ladda !== "undefined") {
        ladda = Ladda.create(this.$refs.btnSalvar);
        ladda.start();
      }

      axios
        .post(this.saveUrl, dados)
        .then(function (response) {
          self.emitirMarcacoesSalvas();
          self.$bvModal.hide("modalParticipantes");
          self.$emit("salvo");
          self.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .catch(function (e) {
          self.notificarErro(e);
        })
        .finally(function () {
          self.salvando = false;

          if (ladda) {
            ladda.stop();
          }
        });
    },

    notificarErro: function (e) {
      var mensagem = "Erro ao salvar a lista de presença.";

      if (e && e.response && e.response.data && e.response.data.message) {
        mensagem = e.response.data.message;
      } else if (e && e.message) {
        mensagem = e.message;
      } else if (e) {
        mensagem = String(e);
      }

      if (this.$snack && this.$snack.danger) {
        this.$snack.danger({
          button: false,
          text: mensagem,
        });
        return;
      }

      if (this.$snack && this.$snack.success) {
        this.$snack.success({
          button: false,
          text: mensagem,
        });
      }
    },
  },
};
</script>

<style scoped>
.presenca-table-wrapper {
  max-height: 440px;
  overflow-y: auto;
}

.presenca-table th,
.presenca-table td {
  vertical-align: middle;
  white-space: nowrap;
}

.nome-participante {
  min-width: 220px;
  white-space: normal;
}

.confirmar-coluna {
  min-width: 150px;
}

.modo-confirmacao {
  max-width: 330px;
}
</style>
